import React, {useState, useEffect } from 'react';
import { Typography, Skeleton, Spin } from 'antd';
import { Container } from '../../components/UI/Container.component';
import { Screen } from '../../components/UI/Screen.component';
import { ScreenHeader } from '../../components/UI/ScreenHeader.component';
import { Section } from '../../components/UI/Section.component';
import { UpdateManagerTable } from '../../components/Dashboard/UpdateManager/UpdateManagerTable.component';
import { Scheduler } from '../../components/Dashboard/UpdateManager/Scheduler.component';
import { requestFiles } from '../../services/UpdateManagerService';

const { Title } = Typography;

const DEFAULT_PAGE = 1;
const DEFAULT_PAGE_SIZE = 10;

export const UpdateManagerScreen = () => {

    const [pagination, setPagination] = useState({current: DEFAULT_PAGE, pageSize: DEFAULT_PAGE_SIZE});
    const [dataSource, setDataSource] = useState(undefined);
    const [search, setSearch] = useState('');

    const [fetchData, setFetchData] = useState(false);
    const [loadingModal, setLoadingModal] = useState(false);
    const [fullRefreshTriggered, setFullRefreshTriggered] = useState(false);

    useEffect(() => {
        setFetchData({triggered: true, fullRefresh: true});
    }, [])

    const refreshHandler = () => {
        setFullRefreshTriggered(true);
        setFetchData({triggered: true, fullRefresh: true})
    }

    useEffect(() => {
        if(fetchData.triggered){
            handleFetch(fetchData.fullRefresh);
            setFetchData({triggered: false, fullRefresh: false});
        }
    }, [fetchData])

    useEffect(() => {
        if(fullRefreshTriggered){
            setFetchData({triggered: true, fullRefresh: true});
        } else {
            setFetchData({triggered: true, fullRefresh: false});
        }
    }, [search, fullRefreshTriggered])

    useEffect(() => {
        setFetchData({triggered: true, fullRefresh: false})
    }, [pagination])

    const handleFetch = (fullRefresh) => {

        let data = { limit: pagination.pageSize, page : pagination.current - 1, filter: search}

        if(fullRefresh){
            setLoadingModal(true);
            setSearch('');
            
            const minDuration = 1500;
            const fetchFilesPromise = requestFiles({...data, filter: ''});
            const timeout = new Promise (resolve => setTimeout(resolve, minDuration));

            Promise.all([fetchFilesPromise, timeout]).then(([response]) => {
                setDataSource(response);
                clearTimeout(timeout);
                setLoadingModal(false);
                setFullRefreshTriggered(false);
            });
        } else {
            requestFiles(data).then((response) => {
                setDataSource(response);
            })
        }
    }

    return(
        <>
            <Screen id="update-manager-screen">
                <Container>
                    <ScreenHeader>
                        <Title>Update Manager</Title>
                    </ScreenHeader>
                    <Section>
                        {loadingModal ? <Skeleton/> :
                            <>
                                { dataSource && <Scheduler dataSource={dataSource} setDataSource={setDataSource} refreshHandler={refreshHandler}/>}
                            </>
                        }
                    </Section>
                    <Section>
                        { loadingModal ? <Skeleton/> :
                            <>
                                { dataSource && 
                                    <UpdateManagerTable 
                                        dataSource={dataSource} 
                                        setDataSource={setDataSource} 
                                        pagination={pagination} 
                                        setPagination={setPagination} 
                                        search={search} 
                                        setSearch={setSearch}
                                        refreshHandler={refreshHandler}
                                    /> 
                                }
                            </>
                        }
                    </Section>
                </Container>
            </Screen>
            <Spin spinning={loadingModal} fullscreen/>
        </>
    );
}